import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "inline"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Form = function Form(_ref) {
  var children = _ref.children,
    inline = _ref.inline,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("form", _extends({
    className: cx({
      form: true,
      inline: inline,
      simple: !inline
    })
  }, props), children);
};
Form.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  inline: PropTypes.bool
} : {};
export var InputGroup = function InputGroup(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('inputGroup', className)
  }, children);
};
InputGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
} : {};
export var InputsRow = function InputsRow(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    _ref3$groups = _ref3.groups,
    groups = _ref3$groups === void 0 ? 1 : _ref3$groups;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('inputsRow', "groups".concat(groups), className)
  }, children);
};
InputsRow.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  groups: PropTypes.oneOf([1, 2, 3])
} : {};
export var Label = function Label(_ref4) {
  var children = _ref4.children,
    htmlFor = _ref4.htmlFor;
  return /*#__PURE__*/React.createElement("label", {
    className: cx('label'),
    htmlFor: htmlFor
  }, children);
};
Label.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any,
  htmlFor: PropTypes.string
} : {};
export var Value = function Value(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("span", {
    className: cx('value')
  }, children);
};
Value.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.string.isRequired
} : {};
export var InputInfo = function InputInfo(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('info')
  }, children);
};
InputInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any.isRequired
} : {};